import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

@Directive({
  selector: '[portalClickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  private readonly element = inject(ElementRef);

  // skipFirstClick in order to not catch the first click which component initialization triggered
  @Input() skipFirstClick = true;
  @Output() readonly portalClickOutside = new EventEmitter();

  clickCount = 0;

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: any) {
    this.clickCount++;

    if (!this.skipFirstClick || this.clickCount !== 1) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      const clickedInside = this.element.nativeElement.contains(targetElement);

      if (!clickedInside) {
        this.portalClickOutside.emit(null);
      }
    }
  }
}
